import { render, staticRenderFns } from "./BatchData.vue?vue&type=template&id=2f8c04ba&"
import script from "./BatchData.vue?vue&type=script&lang=js&"
export * from "./BatchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports